import { Component, computed, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeVideomessage } from '@app/models/entity.model';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { ContentSectionComponent } from '@app/components/content-section/content-section.component';
import { MediaComponent } from '@app/components/media/media.component';
import { MapSmallComponent } from '@app/components/map-small/map-small.component';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { WebformModule } from '@app/components/webform/webform.module';

@Component({
  selector: 'mobi-node-videomessage',
  templateUrl: './node-videomessage.component.html',
  styleUrls: ['./node-videomessage.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    NgxJsonViewerModule,
    HeroTextComponent,
    ContentSectionComponent,
    MediaComponent,
    MapSmallComponent,
    MobiUiIconComponent,
    WebformModule,
  ],
})
export class NodeVideomessageComponent {
  readonly entity = input.required<NodeVideomessage>();

  hasLocation = computed(() => {
    return (
      this.entity()?.person?.locationActivity &&
      this.entity()?.person?.locationActivity.length
    );
  });
}
